// src/api/notificationApi.js
import apiClient from './axios';

const notificationApi = {
  getAll: async (page = 1, pageSize = 10) => {
    const r = await apiClient.get('/notifications/', {
      params: { page, page_size: pageSize },
    });
    return r.data;
  },

  getUnreadCount: async () => {
    const r = await apiClient.get('/notifications/unread-count/');
    return r.data.unread_count;
  },

  markRead: async (id) => {
    await apiClient.post(`/notifications/${id}/mark-read/`, { id });
  },

  markAllRead: async () => {
    const r = await apiClient.post('/notifications/mark-all-read/');
    return r.data.marked_read_count;
  },
};

export default notificationApi;